<div class="p-4">
    <h1 class="mb-4" mat-dialog-title class="sub-header-title">Modify Claim Status  #{{ this.claim.id }}</h1>
    <div mat-dialog-content class="my-5">
        <div class="row mx-2">
            <div class="col-6 d-flex flex-column">
                <div class="col d-flex flex-column sub-form-header-title" style="font-weight:bold;">
                    Current Status:
                </div>
                <div class="col d-flex flex-column sub-form-header-title">
                    {{ this.currentStatus.status_text }}
                </div>
            </div>
            <div class="col-6 d-flex flex-column">
                <form [formGroup]="form">
                    <div class="row">
                        <div class="col d-flex flex-column">
                            <mat-form-field appearance="outline" hideRequiredMarker>
                                <mat-label>New Status<span class="required-input">*</span></mat-label>
                                <mat-select formControlName="status_id">
                                    <mat-option *ngFor="let status of claimStatusSelect" [value]="status.status_id">
                                        {{ status.status_text }}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="form.get('status_id')?.value">Required</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <div class="mt-2 mb-2 d-flex justify-content-end">
        <button mat-raised-button class="cancel-button" (click)="onCancelClick()" style="margin-right:12px">
            <mat-icon>cancel</mat-icon>
            Cancel
        </button>
        <button mat-raised-button class="action-button" (click)="onSubmitClick()" [disabled]="!canUpdateClaim()">
            <mat-icon>check</mat-icon>
            Save Changes
        </button>
    </div>
</div>